import { getDelegations, exportDelegations, postDelegation } from '../../../Api/services/backoffice';

export const key = 'delegation';

const entityName = {
  singular: 'Delegação',
  plural: 'Delegações',
};

const queries = {
  list: { key, fn: getDelegations },
  detail: { key },
};

const mutations = {
  create: postDelegation,
  export: exportDelegations,
};

const fields = {
  table: [
    { key: 'sellerOrigin.name', label: 'Origem' },
    { key: 'sellerDelegation.name', label: 'Delegação' },
    { key: 'initialDate', label: 'Início', mask: 'date' },
    { key: 'expirationDate', label: 'Fim', mask: 'date' },
    { key: 'expirationDate', label: 'Status', mustRender: { componentType: 'status', valueFn: (value) => (new Date(value)) > (new Date()) } },
  ],
  search: [
    {
      param: 'sellerOrigin',
      label: 'Vendedor origem',
      type: 'select',
      optionType: 'sellers',
    },
    {
      param: 'sellerDestination',
      label: 'Vendedor destino',
      type: 'select',
      optionType: 'sellers',
    },
    {
      param: 'startDate',
      label: 'Data de início',
      type: 'date',
    },
    {
      param: 'endDate',
      label: 'Data de fim',
      type: 'date',
    },
  ],
};

export const listConfig = {
  title: entityName.plural,
  tableFields: fields.table,
  searchFields: fields.search,
  queryConfig: queries.list,
  exportFn: mutations.export,
  hideUpdateButton: true,
};

export const createConfig = {
  entityName: entityName.singular,
  mutationFn: mutations.create,
};
